<mat-card appearance="outlined" class="card-container" [ngClass]="{'no-shadow': disableShadow}">
    <div *ngIf="title" class="d-flex flex-row align-items-center mt-3">
        <h2 class="header-title">{{ title }}</h2>
    </div>
    <div class="d-flex flex-wrap mt-3">
        <div *ngFor="let item of data" class="col-lg-4 col-md-6 col-12 flex-column mt-3 mb-3">
            <div class="d-flex flex-row justify-items-center">
                <div class="item-key" [ngStyle]="{'color': item.value === null ? '#FF0000' : '#000000'}">{{ item.displayText }}</div>
                <div class="item-help-icon px-1" *ngIf="item.helpText">
                    <mat-icon [matTooltip]="item.helpText" matTooltipPosition="above">help_outline</mat-icon>
                </div>
            </div>
            <div class="item-value">
                @if(item.isLink) {
                    <span (click)="goToRoute(item)">
                        <a>{{ item.value }}</a>
                    </span>
                } @else {
                    {{ item.value }}
                }
            </div>
        </div>
        <div *ngIf="fullRowData" class="col-12">
            <div class="d-flex flex-row justify-items-center">
                <div class="item-key">{{ fullRowData.displayText }}</div>
                <div class="item-help-icon px-1" *ngIf="fullRowData.helpText">
                    <mat-icon matTooltip="{{ fullRowData.helpText }}" matTooltipPosition="above">help_outline</mat-icon>
                </div>
            </div>
            <div class="item-value">
                @if(fullRowData.isLink) {
                    <span (click)="goToRoute(fullRowData)">
                        <a>{{ fullRowData.value }}</a>
                    </span>
                } @else {
                    {{ fullRowData.value }}
                }
            </div>
        </div>
    </div>
</mat-card>